module.exports = __webpack_public_path__ + "placa_col_estof_10x_s_1x9_carne.png?daa8f041af00062babf313fe6f47036a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/placa_col_estof_10x_s_1x9_carne.png
// module id = 120
// module chunks = 0